
<template>
    <div>
        <section v-show='paginatedData.length == 0' class='emptyResults'>
            <img class='banner' src="dist/assets/banner.png" alt="">
        </section>
        <header v-show='paginatedData.length > 0' class='show-header'>
            <form>
                <input type="radio"  id='small'   checked v-model="pageSize" value=11> 
                <label  @click='changePageSize' for='small'>11</label>
                <input  type="radio" id='medium'  v-model="pageSize" value=25> 
                <label  @click='changePageSize' for='medium'>25</label>
                <input name='large'  type="radio" id='large'  v-model="pageSize" value=50>
                <label  @click='changePageSize' for='large'>50</label>
            </form> 
             <h5>Showing <span v-show='pageCount > 0' class='value-color'>{{(this.pageNumber * this.size)+1}} - <template v-if="this.pageNumber < this.pageCount">{{(this.pageNumber * this.size) + this.size}}</template><template v-else>{{this.listData.length}}</template> </span> <span v-show='pageCount == 0' class='value-color'>{{(this.pageNumber * this.size)+1}} - {{this.listData.length}} </span>  of  <span  class='value-color'>{{this.listData.length}}</span> Total </h5>
        </header>
                    <div v-show='pageCount > 0' class='pagination'>
                    <button class='prev-next' 
                        :disabled="pageNumber === 0" 
                        @click="prevPage">
                        Previous
                    </button>
                                    <ul v-if='pageCount === 0'>
                        <li>
                            <button class='value-color' @click="goToPage(0)" >{{ 1 }}</button>
                        </li>
                    </ul>
                    <ul v-else-if='pageCount > 0 && pageCount < 2'>
                        <li>
                            <button v-bind:class="getClass(0)" @click="goToPage(0)">{{ 1 }}</button>
                        </li>

                        <li>
                            <button v-bind:class="getClass(1)"  @click="goToPage(1)">{{pageCount + 1}}</button>
                        </li>
                    </ul>
                    <ul v-else-if='pageCount > 0 && pageCount < 3'>
                        <li>
                            <button v-bind:class="getClass(0)" @click="goToPage(0)">{{ 1 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(1)" @click="goToPage(1)">{{ 2 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(2)" @click="goToPage(2)">{{pageCount + 1}}</button>
                        </li>
                    </ul>
                    <ul v-else-if='pageCount > 0 && pageCount < 4'>
                        <li>
                            <button v-bind:class="getClass(0)" @click="goToPage(0)">{{ 1 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(1)" @click="goToPage(1)">{{ 2 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(2)" @click="goToPage(2)">{{ 3 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(3)" @click="goToPage(3)">{{pageCount + 1}}</button>
                        </li>
                    </ul>
                    <ul v-else-if='pageCount > 0 && pageCount < 5'>
                        <li>
                            <button v-bind:class="getClass(0)" @click="goToPage(0)" >{{ 1 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(1)" @click="goToPage(1)">{{ 2 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(2)" @click="goToPage(2)">{{ 3 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(3)" @click="goToPage(3)">{{ 4 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(4)" @click="goToPage(4)">{{pageCount + 1}}</button>
                        </li>
                    </ul>
                    <ul v-else-if='pageCount > 0 && pageCount < 6'>
                        <li>
                            <button v-bind:class="getClass(0)"  @click="goToPage(0)">{{ 1 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(1)" @click="goToPage(1)">{{ 2 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(2)" @click="goToPage(2)">{{ 3 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(3)" @click="goToPage(3)">{{ 4 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(4)" @click="goToPage(4)">{{ 5 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(6)" @click="goToPage(5)">{{pageCount + 1}}</button>
                        </li>
                    </ul>
                    <ul v-else>
                        <li>
                            <button v-bind:class="getClass(0)" @click="goToPage(0)">{{ 1 }}</button>
                        </li>
                        <li v-if='pageNumber <= 5'>
                            <button v-bind:class="getClass(1)" @click="goToPage(1)" >{{ 2 }}</button>
                        </li>
                        <li v-if='pageNumber <= 5 && pageNumber < pageCount -2'>
                            <button v-bind:class="getClass(2)" @click="goToPage(2)" >{{ 3 }}</button>
                        </li>
                        <li v-if='pageNumber <= 5 && pageNumber < pageCount -2'>
                            <button v-bind:class="getClass(3)" @click="goToPage(3)" >{{ 4 }}</button>
                        </li>
                            <li v-if='pageNumber >= 6'>
                            <span>...</span>
                            </li>
                        <li v-if='pageNumber >= 6'>
                                <button v-bind:class="getClass(pageNumber-2)" @click="goToPage(pageNumber-2)" >{{ pageNumber-1}}</button>
                        </li>
                        <li v-if='pageNumber <= 5'>
                            <button v-bind:class="getClass(4)" @click="goToPage(4)" >{{ 5 }}</button>
                        </li>
                        <li v-else>
                            <button v-bind:class="getClass(pageNumber-1)" @click="goToPage(pageNumber-1)" >{{ pageNumber}}</button>
                        </li>
        
                        <li v-if='pageNumber >= 5'>
                            <button class='value-color' disabled>{{pageNumber + 1}}</button>
                        </li>

                        <li v-else>
                            <span>...</span>
                        </li>

                        <li v-if='pageNumber >= 5 && pageNumber < pageCount -2'>
                            <button @click="goToPage(pageNumber + 1)" >{{ pageNumber + 2}}</button>
                        </li>
                            <li v-if='pageNumber >= 6 && pageNumber < pageCount -3'>
                            <button @click="goToPage(pageNumber + 2)" >{{pageNumber + 3}}</button>
                            </li>
                            <li v-if='pageNumber >= 6 && pageNumber < pageCount -4'>
                            <span>...</span>
                            </li>
                            <li v-if='pageNumber == 5'>
                            <span>...</span>
                            </li>  
                        <li v-if='(pageNumber <= pageCount -2) && (pageNumber >= pageCount -3)'>
                            <button @click="goToPage(pageCount-1)" >{{pageCount}}</button>
                        </li>
                        <li v-if='(pageNumber < pageCount -3) && (pageNumber >= pageCount -4)'>
                            <span>...</span>
                        </li>
                        <li v-if='pageNumber <= pageCount -1'>
                            <button @click="goToPage(pageCount)" >{{pageCount+1}}</button>
                        </li>

                    </ul>

                    <button class='prev-next'
                        :disabled="(pageNumber) >= pageCount" 
                        @click="nextPage">
                        Next
                    </button>
              </div>

        <!-- End pagination on top -->

        <div class="row" v-for="product in paginatedData" :key="product.index">
              <article class='single-product__container'>
                <header class='single-product__header' v-bind:class='{content_IE: checkIE}'>
                  <h4>{{ product.Centrifuge.split('(').slice(0, -1).toString() }} <span class='single-product__header--subtitle'>({{ product.Centrifuge.split('(').slice(-1).toString() }}</span></h4>
                </header>
        
                <aside  class='single-product__aside' v-bind:class='{float_IE: checkIE}'>
                    
                    <img v-if='checkIE' src="http://dmx.ohaus.com/privateAssets/0/14/4294968886/4294968887/4294968891/4294968892/98789848-a980-4075-a114-320cd663316f.jpg" alt="">
                    <carousel v-else-if='!checkIE' :navigationClickTargetSize="5" :per-page="1" :mouse-drag="false">
                        <slide v-if="imgBase.centrifuges[checkIfImgExist(product.Centrifuge)]">
                        <img v-bind:src="imgBase.centrifuges[checkIfImgExist(product.Centrifuge)]" alt="">
                        </slide>
                        <slide v-if="imgBase.rotors[checkIfImgExist(product.Rotor)]">
                        <img v-bind:src="imgBase.rotors[checkIfImgExist(product.Rotor)]" alt="">
                        </slide>
                        <slide v-if="imgBase.buckets[checkIfImgExist(product.Bucket)]">
                        <img v-bind:src="imgBase.buckets[checkIfImgExist(product.Bucket)]" alt="">
                        </slide>
                        <slide v-if="imgBase.buckets[checkIfImgExist(product.Adapter)]" >
                        <img v-bind:src="imgBase.buckets[checkIfImgExist(product.Adapter)]" alt="">
                        </slide>
                        <slide v-if="imgBase.buckets[checkIfImgExist(product.Rack)]">
                        <img v-bind:src="imgBase.buckets[checkIfImgExist(product.Rack)]" alt="">
                        </slide>
                    </carousel>
                    
                
                </aside>
                <div class='single-product__content' v-bind:class='{content_IE: checkIE}'>
                  <ul  class='single-product__details'>
                    <li><span class='param'>Rotor: </span>{{ product.Rotor }}</li>
                    <li><span class='param'>Bucket: </span>{{ product.Bucket }}</li>
                    <li><span class='param'>Rack: </span>{{ product.Rack }}</li>
                    <li><span class='param'>Max Capacity: </span>{{ product["Max Capacity"] }}</li>
                    <li><span class='param'>Vol/Tube: </span>{{ product["Vol./Tube (ml)"] }}</li>
                    <li><span class='param'>Diameter: </span>{{ product['Diameter (mm)'] }}</li>
                  </ul>
                  <a class='btn--partner-shop' @click='printPDF(product)'><span>REQUEST A QUOTE</span></a>
                </div>
              </article>
          </div>

            <!-- Pagination on bottom -->

            <div v-show='pageCount > 0' class='pagination'>
                    <button class='prev-next' 
                        :disabled="pageNumber === 0" 
                        @click="prevPage">
                        Previous
                    </button>
                                    <ul v-if='pageCount === 0'>
                        <li>
                            <button class='value-color' @click="goToPage(0)" >{{ 1 }}</button>
                        </li>
                    </ul>
                    <ul v-else-if='pageCount > 0 && pageCount < 2'>
                        <li>
                            <button v-bind:class="getClass(0)" @click="goToPage(0)">{{ 1 }}</button>
                        </li>

                        <li>
                            <button v-bind:class="getClass(1)"  @click="goToPage(1)">{{pageCount + 1}}</button>
                        </li>
                    </ul>
                    <ul v-else-if='pageCount > 0 && pageCount < 3'>
                        <li>
                            <button v-bind:class="getClass(0)" @click="goToPage(0)">{{ 1 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(1)" @click="goToPage(1)">{{ 2 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(2)" @click="goToPage(2)">{{pageCount + 1}}</button>
                        </li>
                    </ul>
                    <ul v-else-if='pageCount > 0 && pageCount < 4'>
                        <li>
                            <button v-bind:class="getClass(0)" @click="goToPage(0)">{{ 1 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(1)" @click="goToPage(1)">{{ 2 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(2)" @click="goToPage(2)">{{ 3 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(3)" @click="goToPage(3)">{{pageCount + 1}}</button>
                        </li>
                    </ul>
                    <ul v-else-if='pageCount > 0 && pageCount < 5'>
                        <li>
                            <button v-bind:class="getClass(0)" @click="goToPage(0)" >{{ 1 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(1)" @click="goToPage(1)">{{ 2 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(2)" @click="goToPage(2)">{{ 3 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(3)" @click="goToPage(3)">{{ 4 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(4)" @click="goToPage(4)">{{pageCount + 1}}</button>
                        </li>
                    </ul>
                    <ul v-else-if='pageCount > 0 && pageCount < 6'>
                        <li>
                            <button v-bind:class="getClass(0)"  @click="goToPage(0)">{{ 1 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(1)" @click="goToPage(1)">{{ 2 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(2)" @click="goToPage(2)">{{ 3 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(3)" @click="goToPage(3)">{{ 4 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(4)" @click="goToPage(4)">{{ 5 }}</button>
                        </li>
                        <li>
                            <button v-bind:class="getClass(6)" @click="goToPage(5)">{{pageCount + 1}}</button>
                        </li>
                    </ul>
                    <ul v-else>
                        <li>
                            <button v-bind:class="getClass(0)" @click="goToPage(0)">{{ 1 }}</button>
                        </li>
                        <li v-if='pageNumber <= 5'>
                            <button v-bind:class="getClass(1)" @click="goToPage(1)" >{{ 2 }}</button>
                        </li>
                        <li v-if='pageNumber <= 5 && pageNumber < pageCount -2'>
                            <button v-bind:class="getClass(2)" @click="goToPage(2)" >{{ 3 }}</button>
                        </li>
                        <li v-if='pageNumber <= 5 && pageNumber < pageCount -2'>
                            <button v-bind:class="getClass(3)" @click="goToPage(3)" >{{ 4 }}</button>
                        </li>
                            <li v-if='pageNumber >= 6'>
                            <span>...</span>
                            </li>
                        <li v-if='pageNumber >= 6'>
                                <button v-bind:class="getClass(pageNumber-2)" @click="goToPage(pageNumber-2)" >{{ pageNumber-1}}</button>
                        </li>
                        <li v-if='pageNumber <= 5'>
                            <button v-bind:class="getClass(4)" @click="goToPage(4)" >{{ 5 }}</button>
                        </li>
                        <li v-else>
                            <button v-bind:class="getClass(pageNumber-1)" @click="goToPage(pageNumber-1)" >{{ pageNumber}}</button>
                        </li>
        
                        <li v-if='pageNumber >= 5'>
                            <button class='value-color' disabled>{{pageNumber + 1}}</button>
                        </li>

                        <li v-else>
                            <span>...</span>
                        </li>

                        <li v-if='pageNumber >= 5 && pageNumber < pageCount -2'>
                            <button @click="goToPage(pageNumber + 1)" >{{ pageNumber + 2}}</button>
                        </li>
                            <li v-if='pageNumber >= 6 && pageNumber < pageCount -3'>
                            <button @click="goToPage(pageNumber + 2)" >{{pageNumber + 3}}</button>
                            </li>
                            <li v-if='pageNumber >= 6 && pageNumber < pageCount -4'>
                            <span>...</span>
                            </li>
                            <li v-if='pageNumber == 5'>
                            <span>...</span>
                            </li>  
                        <li v-if='(pageNumber <= pageCount -2) && (pageNumber >= pageCount -3)'>
                            <button @click="goToPage(pageCount-1)" >{{pageCount}}</button>
                        </li>
                        <li v-if='(pageNumber < pageCount -3) && (pageNumber >= pageCount -4)'>
                            <span>...</span>
                        </li>
                        <li v-if='pageNumber <= pageCount -1'>
                            <button @click="goToPage(pageCount)" >{{pageCount+1}}</button>
                        </li>

                    </ul>

                    <button class='prev-next'
                        :disabled="(pageNumber) >= pageCount" 
                        @click="nextPage">
                        Next
                    </button>
              </div>
            
             </div>
</template>



<script>
import jsPDf from 'jspdf';
import Vue from 'vue';
import { Carousel, Slide } from 'vue-carousel';



export default {
        name: 'Products',
        components: {
        Carousel,
        Slide,
  },
    watch: {
        listData: function(){
            return this.pageNumber = 0;
        }
    },
 
  data(){
    return {
        pageNumber : this.pageNumb,
        mouseDrag: true,
        checkIE: false,
        pageSize: 11,
        imgBase : dataIMG
    }
  },
  props:{
    'pageNumb' : app.pageNumb,
    listData:{
      type:Array,
      required:true
    },
    size:{
      type:Number,
      required:false,
      default: 11
    },
  },
  created() {
      this.detectIE();
  },

  methods:{

      checkIfImgExist(arg){
            return arg.split('').slice(arg.indexOf("p/n") + 4, arg.length - 1 ).join('');
      },

      printPDF(product){

            var i = 60;
            var x = 80;
            let pdf = new jsPDF();
            let productName = product.Centrifuge.substring(product.Centrifuge.lastIndexOf('F'))
            var productData = baseProducts[productName.substring(0, productName.indexOf(' '))];
            var headerData = headerTry;
            var footerData = footerTry;
            var findCurlyBraces = /\(([^)]+)\)/g;
            pdf.addImage(headerData, 'PNG', 0, -15, 0, 70);
            pdf.setFontSize(13);
            pdf.addImage(productData, 20, 55, 40, 40);
            pdf.setFontType("bold");
            pdf.text(x,i, 'Centrifuge: ' + product.Centrifuge.replace(findCurlyBraces, ""));
            pdf.text(x,i+=6, product.Centrifuge.match(findCurlyBraces).join());
            pdf.setFontType("normal");
            pdf.setFontSize(10);
            pdf.text(x,i+=8, 'Rotors: ' + product.Rotor);
            pdf.text(x,i+=8, 'Bucket: ' + product.Bucket);
            pdf.text(x,i+=8, 'Rack: ' + product.Rack);
            pdf.text(x,i+=8, 'Adapter: ' + product.Adapter);
            pdf.setFontSize(12);
            pdf.text(20,i+=30, 'OHAUS works with a network of local dealers to provide you with its products. ');
            pdf.text(20,i+=8, 'Please, send this PDF document to');
            pdf.textWithLink('ssc@ohaus.com.', 88, i, {url: 'ssc@ohaus.com'});
            pdf.text(20,i+=8, 'We will forward your information to our local dealer in order to process your request. ');
            pdf.text(20,i+=8, 'For more information on the use of your data, please review our ');
            pdf.textWithLink('Privacy Policy', 141, i, {url: 'https://pl.ohaus.com/en-EU/Legal/Privacy-Policy-en'});
            pdf.text(168, i, ' and ');
            pdf.textWithLink('Terms of Use.', 178, i, {url: 'https://pl.ohaus.com/en-EU/Legal/Terms-and-Conditions-en'});
            pdf.text(20,i+=16, 'OHAUS Europe GmbH');
            pdf.text(20,i+=8, 'Im Langacher 44');
            pdf.text(20,i+=8, 'CH-8606 Greifensee');
            pdf.text(20,i+=8, 'Switzerland');
            pdf.textWithLink('ssc@ohaus.com', 20, i+=8, {url: 'ssc@ohaus.com'});
            pdf.textWithLink('tsc@ohaus.com', 20, i+=8, {url: 'tsc@ohaus.com'});
            pdf.textWithLink('www.ohaus.com', 20, i+=8, {url: 'www.ohaus.com'});
            pdf.addImage(footerData, 'PNG', 0, 230, 212, 70);
            
            pdf.save(product.Centrifuge);
            return true;
      },
       changePageSizeMethod(){
           var test = parseInt(this.pageSize);
           this.size = test;
       },
      detectIE(){
          let ua = window.navigator.userAgent;
          let msie = ua.indexOf('MSIE ');
          let trident = ua.indexOf('Trident/');
  if (msie > 0) {
    this.checkIE = true;

  }else if (trident > 0) {
      this.checkIE = true;

  }else{

      this.checkIE = false;
  }
      },
      nextPage(){
         this.pageNumber++;
         window.scrollTo(0, 0);

      },
      prevPage(){
        this.pageNumber--;
        window.scrollTo(0, 0);

      },
      goToPage(arg){
        this.pageNumber = arg;
        window.scrollTo(0, 0);
      },
      getClass(arg){
          return{
              'value-color': this.pageNumber == arg
          }
      }
  },
  computed:{
     changePageSize(){
           this.pageNumber = 0;
           return this.size = parseInt(this.pageSize);
       },
      

    pageCount(){
      let l = this.listData.length,
          s = this.size;
      return Math.floor(l/s);
    },
    paginatedData(){
      const start = this.pageNumber * this.size,
            end = start + this.size;
      return this.listData
               .slice(start, end);
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Products.vue